import { breakpoints } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Button } from "react-aria-components";

import {
  BrandAsset,
  ButtonGroup,
  GhostIconButton,
  MediaQuery,
  useLayout,
} from "@certn/cascadia-react";
import { useMediaQuery } from "@certn/cascadia-react/hooks/useMediaQuery";

import { NavigationBar } from "./NavigationBar";
import { Search } from "../../search/Search";

interface PrimaryNavProps {
  testID: string;
  searchPlaceholder?: string;
  onLogoPress?(): void;
  children?: React.ReactNode;
}

export function PrimaryTopNav(props: PrimaryNavProps) {
  const { testID, children } = props;
  const isSmallScreen = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-md"].maxWidth.toString()}px)`
  );

  const { toggleMenu, menuPosition, hasNavigation } = useLayout();

  const { search, setSearch } = useLayout();

  if (search !== undefined && isSmallScreen) {
    return (
      <NavigationBar testID={`${testID}-searching`}>
        <GhostIconButton
          icon="arrow_back"
          color="icon-weak"
          onPress={() => setSearch(undefined)}
        />
        <ButtonGroup>
          <Search
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            name="search"
            value={search}
            onChange={(value) => {
              setSearch(value.length > 0 ? value : undefined);
            }}
            testID="top-nav-search"
            compact={false}
          />
        </ButtonGroup>
      </NavigationBar>
    );
  }

  return (
    <NavigationBar testID={testID}>
      <MediaQuery type="show" sm md>
        <ButtonGroup justify="end">
          {menuPosition === "left" && hasNavigation && (
            <MediaQuery type="show" sm md>
              <GhostIconButton icon="menu" onPress={() => toggleMenu(true)} />
            </MediaQuery>
          )}
          <Button
            className={css(
              styles.logo,
              {
                aspectRatio: "62/64",
                "&[data-focus-visible]": {
                  boxShadow: "var(--focus-action)",
                },
              },
              props.onLogoPress && { cursor: "pointer" }
            )}
            onPress={props.onLogoPress}
          >
            <BrandAsset brand="certn" type="logo" height="100%" width="100%" />
          </Button>
        </ButtonGroup>
      </MediaQuery>
      <MediaQuery type="hide" sm md>
        <Button
          className={css(
            styles.logo,
            {
              aspectRatio: "219/64",
              "&[data-focus-visible]": {
                boxShadow: "var(--focus-action)",
              },
            },
            props.onLogoPress && { cursor: "pointer" }
          )}
          onPress={props.onLogoPress}
        >
          <BrandAsset brand="certn" type="full" height="100%" width="100%" />
        </Button>
      </MediaQuery>
      <ButtonGroup justify="end">
        {children}
        {menuPosition === "right" && hasNavigation && (
          <MediaQuery type="show" sm md>
            <GhostIconButton icon="menu" onPress={() => toggleMenu(true)} />
          </MediaQuery>
        )}
      </ButtonGroup>
    </NavigationBar>
  );
}

const styles = {
  children: css({ display: "flex" }),
  logo: css({
    background: "transparent",
    border: "none",
    outline: "none",
    height: "30px",
    cursor: "pointer",
    padding: 0,
    margin: 0,
    borderRadius: "var(--border-radius-2)",
  }),
};
